import { Component, inject } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { BuyBookModalComponent } from '../bookviewer/pages/modal-container/buy-book-modal/buy-book-modal.component';
import { BookFeatureService } from '../../services/book-feature.service';
import { ApplicationStateService } from '../../services/application-state.service';

@Component({
    selector: 'app-buy-book',
    templateUrl: './buy-book.component.html',
    styleUrls: ['./buy-book.component.scss'],
    standalone: true
})
export class BuyBookComponent {
    private modalService = inject(ModalService);
    private bookFeatureService = inject(BookFeatureService);
    private applicationStateService = inject(ApplicationStateService);

    openBuyBookModal(): void {
        this.handleClosingTools()
        this.modalService.openModal(BuyBookModalComponent);
    }

    /**
     * controls whether BookViewer tools are closed when modal is opened.
     */
    handleClosingTools(): void {
        if (this.applicationStateService.pageEditMode.type === 'DRAW' ||
            this.applicationStateService.pageEditMode.type === 'SELECTION' ||
            this.applicationStateService.pageEditMode.type === 'RECT') {
            this.bookFeatureService.dismissMode()
        }
    }
}
